import { createRouter, createWebHashHistory } from "vue-router";
import AdminHomeView from "../components/AdminHome.vue"
import AddProduct from "../components/addproduct.vue"
import Home from "../views/Home.vue"

const routes = [

    {
        path: "/",
        component: Home,
        children: [
        ]
    },
    {
        path: "/admin",
        component: AdminHomeView,
        children: [
            {
                path: "/addproduct",
                component: AddProduct
            },

            {
                path: "/people",
                component: () => import("../components/people.vue")
            },

            {
                path: "/updatepeople/:id",
                component: () => import("../components/updatepeople.vue")
            },
            {
                path: "/updateproduct/:id",
                component: () => import("../components/updateproduct.vue")
            },
            {
                path: "/updateorder/:id",
                component: () => import("../components/updateorder.vue")
            },
              {
                path: "/catalogInfo",
                component: () => import("../components/catalog/CatalogInfo.vue")
            },

        ]
    },
    {
        path: "/login",
        component: () => import("../components/login.vue")
    },
    {
        path: "/register",
        component: () => import("../components/register.vue")
    }

]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

router.beforeEach((to, from, next) => {

    // 检查用户是否已登录
    const isAuthenticated = sessionStorage.getItem("s") === "true";
    if (to.path === '/login' || to.path === '/register' || to.path === '/') {
        // 如果用户已登录，并且尝试访问登录或注册页面，则重定向到首页
        next();
    } else {
        // 如果用户已登录，则允许访问其他页面；如果未登录，则重定向到登录页面
        if (isAuthenticated) {
            next();
        } else {

            // 如果当前路由是登录页，则直接放行，避免无限重定向
            if (to.path === '/login') {
                next();
            } else {
                next('/login');
            }
        }
    }

})

export default router;